import { render, staticRenderFns } from "./u-card-flat-tile.vue?vue&type=template&id=2c8e4aac&scoped=true&"
import script from "./u-card-flat-tile.vue?vue&type=script&lang=js&"
export * from "./u-card-flat-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e4aac",
  null
  
)

export default component.exports